export const CBRE_FLOW_LAB_INSTRUMENT_FILTER_GET_ALL_LOOKUPS_SUCCESS =
    'CBRE-FLOW-LAB-INSTRUMENT-FILTER/GET_ALL_LOOKUPS_SUCCESS';
export const CBRE_FLOW_LAB_INSTRUMENT_FILTER_GET_ALL_LOOKUPS_FAILURE =
    'CBRE-FLOW-LAB-INSTRUMENT-FILTER/GET_ALL_LOOKUPS_FAILURE';
export const MODULE = 'cbre-flow-lab-instrument-filter';